import React from "react";

function GuardCustomer() {
    return (
        <div>
            <h2>Customer Service & Professional Standards</h2>
            <p>
                Security guards are often the first point of contact for staff, visitors, and the public. This module explores how to deliver excellent customer service while maintaining authority, professionalism, and safety.
            </p>

            <h3>The Importance of Customer Service</h3>
            <ul>
                <li>Creates a positive first impression</li>
                <li>Builds trust and cooperation with the public</li>
                <li>Reduces conflict and improves compliance</li>
                <li>Reflects positively on your employer and the industry</li>
            </ul>

            <h3>Professional Conduct</h3>
            <ul>
                <li>Be punctual, reliable, and well-groomed</li>
                <li>Wear the correct uniform and ID badge</li>
                <li>Remain calm, polite, and respectful at all times</li>
                <li>Follow company policies and site procedures</li>
            </ul>

            <h3>Communication with the Public</h3>
            <ul>
                <li>Greet people warmly and offer assistance</li>
                <li>Listen actively and respond clearly</li>
                <li>Use positive body language and tone</li>
                <li>Remain professional even when challenged</li>
            </ul>

            <h3>Equality, Diversity & Inclusion</h3>
            <ul>
                <li>Treat everyone fairly and without bias</li>
                <li>Respect cultural, religious, and personal differences</li>
                <li>Challenge discrimination and report inappropriate behavior</li>
                <li>Understand the Equality Act 2010 and its protections</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> A visitor becomes frustrated after being asked to sign in. How do you maintain professionalism and resolve the situation calmly?
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Customer Service Training</a></li>
                <li><a href="https://www.acas.org.uk/equality" target="_blank" rel="noreferrer">ACAS – Equality and Diversity at Work</a></li>
                <li><a href="https://www.equalityhumanrights.com/en" target="_blank" rel="noreferrer">Equality & Human Rights Commission</a></li>
            </ul>
        </div>
    );
}

export default GuardCustomer;
